import { IconButtonProps } from 'components/IconButton/Types'
import { comparer, computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { type DocStore } from 'stores/DocStore'
import { CollabItemInteractionButton } from '../CollabItemInteractionButton/CollabItemInteractionButton'

interface CommentInteractionButtonProps extends Partial<IconButtonProps> {
  uuids: string[]
  docStore: DocStore
}

export const CommentInteractionButton = observer(
  ({ className, uuids, docStore, ...additonalProps }: CommentInteractionButtonProps) => {
    const comments = computed(() => docStore.comments.filter((c) => c.uuid && uuids.includes(c.uuid)), {
      equals: comparer.structural,
    }).get()

    return (
      <CollabItemInteractionButton
        className={className}
        collabType="comment"
        items={comments}
        selectFn={docStore.rootStore.comments.select}
        {...additonalProps}
      />
    )
  },
)
